import { useContext } from "react";
import { Constants } from "../../../../../../../common/constants";
import { RouterInferenceHelpers } from "../../../../../../../src/api/trpc/rootRouter";
import { GuildListContext } from "../../../../sesh_router";
import { Tag } from "../../base_components/tag";
import { GenericEntitlement } from "./generic_entitlement";

export function DiscordEntitlement(
	props: RouterInferenceHelpers["premium"]["getUserPremiumDetails"]["output"]["discord_entitlements"][number]
) {
	const guild_list = useContext(GuildListContext);

	const activated_guild = guild_list.find((val) => val.id === props.guildId);

	const is_one_time_purchase =
		props.sku_id === Constants.DISCORD_ONE_TIME_PURCHASE_BUNDLE_SKU_ID ||
		props.sku_id === Constants.DISCORD_ONE_TIME_PURCHASE_SINGLE_SKU_ID;

	return (
		<GenericEntitlement
			title={"Discord Premium"}
			type={"Discord"}
			payment_interval={is_one_time_purchase ? "one-time" : "monthly"}
			modify_link={
				<a
					className="secondary-link"
					target="_blank"
					href={Constants.DISCORD_PREMIUM_MANAGEMENT_FAQ_LINK}
				>
					Modify <i className="fas fa-external-link-alt" />
				</a>
			}
			details={
				<div className="flex w-full">
					<div>
						{is_one_time_purchase ? (
							<>
								Activations Granted:{" "}
								<span className="font-bold">
									{props.sku_id ===
									Constants.DISCORD_ONE_TIME_PURCHASE_SINGLE_SKU_ID
										? 1
										: 3}
								</span>
							</>
						) : (
							<>
								Server:{" "}
								<span className="font-bold">
									{activated_guild?.name
										? `${activated_guild.name} (${props.guildId})`
										: props.guildId}
								</span>
							</>
						)}
					</div>
				</div>
			}
		/>
	);
}
